export enum EPositionControl {
  Next = 'next_option_store',
  Previous = 'previous_option_store',
}
